module.exports = __webpack_public_path__ + "img/289b3eb.png";